var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPredict(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3751 18.9996L6.7001 13.1496L0.850098 10.4746L6.7001 7.82461L9.3751 1.97461L12.0251 7.82461L17.9001 10.4746L12.0251 13.1496L9.3751 18.9996ZM18.9001 22.0246L17.5751 19.0746L14.6251 17.7746L17.5751 16.4246L18.9001 13.4996L20.2251 16.4246L23.1501 17.7746L20.2251 19.0746L18.9001 22.0246Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredict);
export default __webpack_public_path__ + "static/media/predict.3a4158929ead4a2edee50f0f42985fea.svg";
export { ForwardRef as ReactComponent };